import { Flex } from "@chakra-ui/react";
import { Grid } from "components";
import { DisplayPerformanceFilters } from "../../types";
import { AccountsPerformanceRequests } from "../../requests.types";
import {
  AccountAndPersonaInsights,
  AccountMovement,
  AccountsInBuyerResearchStage,
  AccountsReachedOverTime,
  AccountStatCards,
  EngagementAcrossPersonas,
  IntegratedCampaignReport,
  TopAccounts,
} from "./components";

type AccountsPerformanceProps = {
  campaignName: string;
  id: string;
  companyId?: number | string;
  filters: DisplayPerformanceFilters;
  requests: AccountsPerformanceRequests;
  isBasicView?: boolean;
};

const AccountsPerformance = ({
  campaignName,
  id,
  companyId,
  filters,
  requests,
  isBasicView,
}: AccountsPerformanceProps) => {
  return (
    <>
      <AccountStatCards
        campaignId={id}
        filters={filters}
        getAccountLifts={requests.getAccountLifts}
        getStatistics={requests.getStatistics}
        isBasicView={isBasicView}
      />

      <Flex w="100%" gap={4}>
        <AccountsReachedOverTime
          campaignId={id}
          filters={filters}
          getAccountLifts={requests.getAccountLifts}
        />

        <AccountsInBuyerResearchStage
          campaignId={id}
          filters={filters}
          getAccountInBuyerResearchStage={
            requests.getAccountInBuyerResearchStage
          }
        />

        {!isBasicView && requests.getAccountEngagement && (
          <AccountMovement
            campaignId={id}
            filters={filters}
            getAccountEngagement={requests.getAccountEngagement}
          />
        )}
      </Flex>

      {!isBasicView && (
        <Flex w="100%" gap={4} marginY={4}>
          {requests.getEngagementAcrossPersonas && (
            <EngagementAcrossPersonas
              campaignId={id}
              filters={filters}
              getEngagementAcrossPersonas={requests.getEngagementAcrossPersonas}
            />
          )}
          {requests.getAccountAndPersonasInsights && (
            <AccountAndPersonaInsights
              campaignId={id}
              filters={filters}
              getAccountAndPersonasInsights={
                requests.getAccountAndPersonasInsights
              }
            />
          )}
        </Flex>
      )}

      <Flex w="100%" gap={4} marginY={4}>
        <IntegratedCampaignReport
          campaignId={id}
          filters={filters}
          getIntegratedCampaignReport={requests.getIntegratedCampaignReport}
        />
      </Flex>

      <Grid>
        {getShouldShowTopAccounts(companyId) && (
          <TopAccounts
            campaignName={campaignName}
            campaignId={id}
            filters={filters}
            getTopAccounts={requests.getTopAccounts}
            hideSpendColumn={isBasicView}
          />
        )}
      </Grid>
    </>
  );
};

const getShouldShowTopAccounts = (companyId?: number | string) => {
  if (!companyId) {
    return false;
  }

  // https://intentsify.atlassian.net/browse/IP-2405
  // We don't want to show the top accounts for the following companies (Verizon)
  if (companyId === 276) {
    return false;
  }

  return true;
};

export { AccountsPerformance };
